import React /*, { useState } */ from 'react';

const NoahKatzWebsite = () => {
  // const [expandedSections, setExpandedSections] = useState({});

  // const toggleSection = (sectionId) => {
  //   setExpandedSections(prev => ({
  //     ...prev,
  //     [sectionId]: !prev[sectionId]
  //   }));
  // };

  // const ExpandableSection = ({ id, title, children }) => (
  //   <div className="mt-10">
  //     <div 
  //       className="cursor-pointer flex items-center text-base text-slate-700 mb-4 hover:text-slate-900 transition-colors"
  //       onClick={() => toggleSection(id)}
  //     >
  //       <span className={`mr-2 transition-transform duration-200 ${expandedSections[id] ? 'rotate-90' : ''}`}>
  //         ▶
  //       </span>
  //       {title}
  //     </div>
  //     {expandedSections[id] && (
  //       <div className="pl-5 text-slate-600 leading-relaxed">
  //         {children}
  //       </div>
  //     )}
  //   </div>
  // );

  const ExperienceItem = ({ title, company, date, description, techStack, link }) => (
    <div className="mb-8 pb-5 last:border-b-0 border-b border-slate-100">
      <h3 className="text-lg font-medium text-slate-800 mb-1">{title}</h3>
      {
        link ? 
          <a href={link} target="_blank" rel="noopener noreferrer" className="text-base text-blue-500 hover:text-blue-600 transition-colors">
            {company}
          </a>
          :
          <div className="text-base text-blue-500 mb-1">{company}</div>
      }
      <div className="text-sm text-slate-500 mb-2">{date}</div>
      <p className="text-sm text-slate-600 leading-relaxed mb-2">{description}</p>
      <div className="text-sm text-slate-500 italic">{techStack}</div>
    </div>
  );

  const EducationItem = ({ degree, school, date, minor }) => (
    <div className="mb-8 pb-5 last:border-b-0 border-b border-slate-100">
      <h3 className="text-lg font-medium text-slate-800 mb-1">{degree}</h3>
      <div className="text-base text-blue-500 mb-1">{school}</div>
      <div className="text-sm text-slate-500 mb-2">{date}</div>
      {minor && <div className="text-sm text-slate-500 italic">{minor}</div>}
    </div>
  );

  const ProjectCard = ({ title, description, link }) => (
    <div className="border border-slate-200 rounded-lg p-6 hover:shadow-lg transition-shadow duration-200">
      <h3 className="text-lg font-medium text-slate-800 mb-3">{title}</h3>
      <p className="text-sm text-slate-600 leading-relaxed mb-3">{description}</p>
      {link && (
        <a 
          href={link} 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-sm text-blue-500 hover:underline"
        >
          View Project
        </a>
      )}
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto px-5 py-16 font-sans text-slate-800 bg-white min-h-screen">
      {/* Header */}
      <header className="text-center mb-16">
        <img src="/imgs/me.png" alt="Noah Katz" className="w-48 h-48 rounded-full mx-auto mb-8" />
        <h1 className="text-5xl font-light text-slate-700 mb-4 tracking-tight">Noah Katz</h1>
        <p className="text-lg text-slate-500 mb-5">Software Engineer</p>
        <p className="text-base text-slate-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          My goal is to build innovative software solutions that solve real-world problems.
        </p>
        <div className="flex justify-center gap-5 flex-wrap">
          <a href="https://calendly.com/katznoah/30min" target="_blank" rel="noopener noreferrer" className="text-base text-blue-500 hover:text-blue-600 transition-colors">
            Calendly
          </a>
          <a href="https://linkedin.com/in/noahkatz2" target="_blank" rel="noopener noreferrer" className="text-base text-blue-500 hover:text-blue-600 transition-colors">
            LinkedIn
          </a>
          <a href="https://github.com/katznoah" target="_blank" rel="noopener noreferrer" className="text-base text-blue-500 hover:text-blue-600 transition-colors">
            GitHub
          </a>
          <a href="mailto:noahkatz@gmail.com" className="text-base text-blue-500 hover:text-blue-600 transition-colors">
            Email
          </a>
        </div>
      </header>

      <main>
        {/* Latest News */}
        <section className="mb-12">
          <h2 className="text-2xl font-normal text-slate-700 mb-6 pb-3 border-b border-slate-200">News</h2>
          <ul className="space-y-4">
            <li>
              <strong>2025-09:</strong> New job at <a rel="noreferrer" target="_blank" href="https://parloa.com" className="text-blue-500 hover:underline">Parloa</a>!
            </li>
            <li>
              <strong>2025-07:</strong> Finished an MVP of <a rel="noreferrer" target="_blank" href="https://buildwithbengal.com" className="text-blue-500 hover:underline">Bengal</a>, an AI tool orchestration framework and SDK for the OpenAI API.
            </li>
            <li>
              <strong>2025-06:</strong> Launched <a rel="noreferrer" target="_blank" href="https://justsmartfitness.com" className="text-blue-500 hover:underline">Justsmart Fitness</a>, a chat application to manage diet goals and track progress.
            </li>
            <li>
              <strong>2024-08:</strong> Promoted to Senior Field Engineer at ALTR, continuing to lead critical data security projects in the Office of CTO.
            </li>
            <li>
              <strong>2024-08:</strong> Completed Master of Science in Computer Science at Stevens Institute of Technology.
            </li>
          </ul>
        </section>

        {/* Experience */}
        <section className="mb-12">
          <h2 className="text-2xl font-normal text-slate-700 mb-6 pb-3 border-b border-slate-200">Experience</h2>
          
          <ExperienceItem
            title="Senior Forward Deployed Engineer"
            link="https://parloa.com"
            company="Parloa"
            date="September 2025 - Present"
            description="Building AI Agents!"
          />
          
          <ExperienceItem
            title="Senior Field Engineer"
            company="ALTR"
            date="September 2024 - August 2025"
            description="Senior Engineer in Office of CTO; Owning Data Security Software Projects, AI-powered solutions, and GitLab Pipelines and Terraform for AWS infrastructure management."
            techStack="Python, Node.js, SQL, Snowflake, OpenAI, AWS, Terraform, Jira, GitLab, GitHub"
          />

          <ExperienceItem
            title="Field Engineer"
            company="ALTR"
            date="August 2022 - September 2024"
            description="Engineer in Office of CTO; Resident Engineer at Leading National Financial Institution, developing secure data solutions."
            techStack="Python, Node.js, React, SQL, Snowflake, AWS, GitHub"
          />

          <ExperienceItem
            title="Software Engineer"
            company="Impulse Dynamics"
            date="January 2022 - August 2022"
            description="Led implementation of new features on a TCP Server & Full-Stack Remote Patient Monitoring System for medical device applications."
            techStack="Node.js, Express, React, Python, AWS"
          />
        </section>

        {/* Projects */}
        <section className="mb-12">
          <h2 className="text-2xl font-normal text-slate-700 mb-6 pb-3 border-b border-slate-200">Projects</h2>
          <p className="mb-5 text-slate-500">I love talking about my work - reach out if you have any questions or want to see how it works!</p>
          
          <div className="grid gap-8">
            <ProjectCard
              title="Bengal - OpenAI Tool Manager"
              description="An AI tool orchestration framework and SDK for the OpenAI API. It seamlessly integrates MCP servers and custom function tools with AWS Lambda as a tool invocation runtime."
              link="https://www.buildwithbengal.com/"
            />

            <ProjectCard
              title="Justsmart Fitness"
              description="A chat application to manage diet goals and track progress, providing personalized recommendations and progress analytics."
              link="https://justsmartfitness.com/"
            />

            <ProjectCard
              title="RF Data Classification with Deep Learning"
              description="A Deep Learning model & full-stack application to classify RF data from a Vector Network Analyzer, featuring advanced signal processing and machine learning techniques."
            />
          </div>
        </section>

        {/* Education */}
        <section className="mb-12">
          <h2 className="text-2xl font-normal text-slate-700 mb-6 pb-3 border-b border-slate-200">Education</h2>
          
          <EducationItem
            degree="Master of Science, Computer Science"
            school="Stevens Institute of Technology"
            date="2023 - 2024"
            minor="Focus: Machine Learning and Natural Language Processing"
          />

          <EducationItem
            degree="Bachelor of Arts, Computer Science"
            school="University of Delaware"
            date="2018 - 2022"
            minor="Minor: Legal Studies"
          />
        </section>

        {/* Expandable Sections */}
        {/* <ExpandableSection id="personal" title="Personal characteristics">
          <p>
            I'm passionate about solving complex problems through elegant code and innovative thinking. I enjoy working at the intersection of technology and business, finding ways to translate technical solutions into real-world value. Outside of work, I'm always learning new technologies and contributing to open-source projects.
          </p>
        </ExpandableSection>

        <ExpandableSection id="interests" title="Things I love">
          <p>
            Full-stack development, cloud architecture, machine learning, data security, open-source software, problem-solving, continuous learning, and building products that make a difference. I'm particularly excited about the intersection of AI and traditional software engineering.
          </p>
        </ExpandableSection>

        <ExpandableSection id="beliefs" title="Things I believe in">
          <p>
            Technology should be accessible, secure, and beneficial to everyone. Good software is not just functional but also maintainable, scalable, and user-friendly. Continuous learning and adaptation are essential in our rapidly evolving field. Collaboration and knowledge sharing make us all better engineers.
          </p>
        </ExpandableSection> */}
      </main>

      {/* Footer */}
      <footer className="text-center mt-16 pt-8 border-t border-slate-200 text-sm text-slate-500">
        <p>© 2025 Noah Katz. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default NoahKatzWebsite;